const twoColumnConfigAggregator = (node) => {
    console.log(node)
    const widgetConfig = Array.from(node.attributes)
        .filter((attr) =>
            [
                'data-w-',
                'data-align-content',
                'data-new-option',
                'data-widget-type',
                'data-appearance'
            ].some(
                (prefix) =>
                    attr.name.startsWith(prefix) ||
                    attr.name === 'data-appearance'
            )
        )
        .reduce((acc, attr) => {
            const name = attr.name
            let attrNameWithoutData
            if (name.startsWith('data-w-')) {
                attrNameWithoutData = name.slice(7) // Remove `data-w-`
            } else if (name === 'data-widget-type') {
                attrNameWithoutData = 'widget-type'
            } else {
                attrNameWithoutData = name.slice(5)
            }

            acc[attrNameWithoutData] = attr.value
            return acc
        }, {})

    const widgetContentElement = node.querySelector(
        '[data-element="widget_content"]'
    )
    const description = widgetContentElement?.innerHTML.trim() || ''

    return {
        html: node.innerHTML,
        widgetConfiguration: {
            ...widgetConfig,
            description
        }
    }
}

export default twoColumnConfigAggregator
